"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCaptureRouteNotFound = exports.RouteNotFound = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Loader_1 = require("../../ui/loader/Loader");
exports.RouteNotFound = function () { return react_1.default.createElement(react_router_dom_1.Redirect, { to: { state: { notFoundError: true } } }); };
exports.useCaptureRouteNotFound = function (notFoundComponent) {
    return react_router_dom_1.withRouter(function (_a) {
        var children = _a.children;
        var NotFoundComponent = Loader_1.lazyLoad(notFoundComponent);
        var location = react_router_dom_1.useLocation();
        return location && location.state && location.state.notFoundError ? (react_1.default.createElement(NotFoundComponent, null)) : children ? (children) : null;
    });
};
//# sourceMappingURL=NotFound.js.map